export const messageTime = (message) => {
  const raw = message?.createdAt ?? message?.created_at ?? message?.timestamp ?? message?.updatedAt ?? message?.updated_at;
  const value = typeof raw === 'number' ? raw : new Date(raw || 0).getTime();
  return Number.isFinite(value) ? value : 0;
};

export const sortMessages = (messages) => (
  [...messages].sort((a, b) => {
    const diff = messageTime(a) - messageTime(b);
    if (diff !== 0) return diff;
    const orderA = a?.bot_data?.order_id ?? a?.botData?.order_id ?? null;
    const orderB = b?.bot_data?.order_id ?? b?.botData?.order_id ?? null;
    if (orderA !== null && orderB !== null && orderA !== orderB) {
      return Number(orderA) - Number(orderB);
    }
    const idA = String(a?.id || a?.temp_id || a?.tempId || '');
    const idB = String(b?.id || b?.temp_id || b?.tempId || '');
    return idA.localeCompare(idB);
  })
);
